import { schema } from 'normalizr'

export const rate = new schema.Entity('rates')
export const arrayOfRates = new schema.Array(rate)



// WEBPACK FOOTER //
// ./src/adapters/easymsRateSchema.js